module.exports = __webpack_public_path__ + "assets/img/Preview_tit.8817a2d5.png";